import React from 'react';
import ReportingMembershipsPage from '../components/ReportingMembershipsPage';

const ReportingMembershipsApp = (props) => (
  <ReportingMembershipsPage {...props} />
);

export default ReportingMembershipsApp;
